import { render, staticRenderFns } from "./LogoTitleSubtitle.vue?vue&type=template&id=5fc09330&scoped=true&"
import script from "./LogoTitleSubtitle.vue?vue&type=script&lang=js&"
export * from "./LogoTitleSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./LogoTitleSubtitle.vue?vue&type=style&index=0&id=5fc09330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc09330",
  null
  
)

export default component.exports